export const ActionTypes = {
  SHOW_MESSAGE_NAVIGATION_DIALOG: 'SHOW_MESSAGE_NAVIGATION_DIALOG',
  HIDE_MESSAGE_NAVIGATION_DIALOG: 'HIDE_MESSAGE_NAVIGATION_DIALOG',
} as const

export type MessageNavigationDialogVariant = 'error' | 'success'

export type ShowMessageNavigationDialogPayload = {
  message: string
  variant: MessageNavigationDialogVariant
  path: string
  actionTitle: string
}

export const showMessageNavigationDialogAction = (
  payload: ShowMessageNavigationDialogPayload
) => ({
  type: ActionTypes.SHOW_MESSAGE_NAVIGATION_DIALOG,
  payload,
})

export const hideMessageNavigationDialogAction = () => ({
  type: ActionTypes.HIDE_MESSAGE_NAVIGATION_DIALOG,
})
